import { useState, useEffect } from "react";

export type SubmitErrorType = Record<string, any>;
export const useFormErrors = <T extends SubmitErrorType>(submitErrors: T) => {
  const [errors, setErrors] = useState<T>({} as T);

  useEffect(() => {
    setErrors(submitErrors);
  }, [submitErrors]);

  const clearError = (key: string) => {
    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      if (key in newErrors) {
        delete newErrors[key];
      }
      return newErrors;
    });
  };

  return { errors, clearError };
};
